import React,{ useState } from 'react'
import { db } from '../../firebase/firebase'
import {collection, addDoc, serverTimestamp, updateDoc, doc } from 'firebase/firestore'
import { useContext } from 'react'
import { CartContext } from '../context/CartContext'
import { useAuth } from '../context/AuthContext'

const Form = () => {

  const { user } = useAuth()

  const [buyerData, setBuyerData] = useState({
    nombre: '',
    celular: '',
    email: user.email
  })

  const [buyerId, setBuyerId] = useState('')
  const [loading, setLoading] = useState(false)

  const { products, total } = useContext(CartContext)

  const addData = (evt) =>{
    const {target} = evt
    setBuyerData(prevBuyerData => {
      return {
        ...prevBuyerData,
        [target.name]: target.value
      }
    })
  }

  const checkout = async (evt) =>{
    setLoading(true)
    evt.preventDefault()
    const ventasCollection = collection(db, 'ventas')
    const buyerInfo = await addDoc(ventasCollection, {
      buyerData,
      products,
      date: serverTimestamp(),
      total
    })
    setBuyerId(buyerInfo.id)
    setBuyerData({
      nombre: '',
      celular: '',
      email: user.email
    })  
    updateStock()
    setLoading(false)
  }

  const updateStock = () =>{
    products.forEach(product => {
      const updateCollection = doc(db, 'productos', product.id)
      updateDoc(updateCollection, {stock: product.stock - product.quantity})
    })
  }


  return (
    <section className='w-full max-w-xs m-auto mt-6 text-center'>
      <h2 className='text-lg text-center '>Por favor, completa el siguiente formulario</h2>
      <form onSubmit={(evt) => checkout(evt)} className='flex flex-col px-3 py-5 mt-6 space-y-4 text-left border-2 rounded-md border-slate-800'>
        <label htmlFor="nombre">Nombre Completo:</label>
        <input className='p-1 rounded-md shadow-lg '
          type="text"
          name='nombre' 
          id='nombre' 
          placeholder='Juan Perez' 
          required
          onChange={(evt) => addData(evt)}
          value={buyerData.nombre}
          />
        <label htmlFor="celular">Celular:</label>
        <input className='p-1 rounded-md shadow-lg ' 
          type="tel" 
          name='celular' 
          id='celular' 
          placeholder='(111) 111 111' 
          required
          onChange={(evt) => addData(evt)}
          value={buyerData.celular}
        />
        <p>Comprando como <span className=' font-bold'>{user.email}</span></p>
        <button className=' btn-primary'>Confirmar</button>
      </form>
      {buyerId && <h3 className='text-xl'>Perfecto! tu ID de compra es: <strong>{buyerId}</strong></h3> }
      {loading && <h3>Procesando...</h3>}
    </section>
  )
}

export default Form